import { Box, Flex, Space, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

interface IPropsErrorBox {
  result: {
    fileName?: string;
    errorMessage?: string;
  };
}

export default function ErrorBox(props: IPropsErrorBox) {
  const { result } = props;
  const errorMessage = result.errorMessage ?? '';
  const fileName = result.fileName ?? '';

  return (
    <Box
      p="md"
      style={(theme) => ({
        borderRadius: theme.radius.sm,
        border: `1px solid ${theme.colors.red[5]}`,
        backgroundColor: theme.colors.red[0],
      })}
    >
      <Text fw={500} mb={4}>
        {fileName}
      </Text>
      <Flex justify={'space-between'} align="center" gap="md">
        <div>
          <Flex align="center" gap="4px">
            <IconAlertCircle color="red" size={16} style={{ flexShrink: 0 }} />
            <Text size="sm" c="red">
              {errorMessage.includes('file fail') ? '분석 실패 - 파일 손상 또는 지원되지 않는 형식' : '변환 실패'}
            </Text>
          </Flex>
          <Space h="sm" />
          <Flex align="flex-start" gap="4px">
            <Text
              size="sm"
              c="red"
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {errorMessage.includes('file fail')
                ? '상세 사유 : 파일이 손상되었거나 지원되지 않는 형식입니다.'
                : `상세 사유 : ${errorMessage}`}
            </Text>
          </Flex>
        </div>
      </Flex>
    </Box>
  );
}
